import React from "react";
import createReactClass from "create-react-class";
import ModalPortal from "./ModalPortal";
import omit from "lodash/omit";
import some from "lodash/some";
import findLast from "lodash/findLast";
import map from "lodash/map";
import keys from "lodash/keys";
import bodyScrollLockManager from "util/bodyScrollLockManager";
import classNames from "classnames";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { ActionRootContext } from "higher-order/ActionRoot";

// This is the root level component that is responsible for displaying the visible modals.
const ModalContainer = createReactClass({
    events() {
        return {
            SHOW_MODAL: this.showModal,
            HIDE_MODAL: this.hideModal
        };
    },

    componentDidMount() {
        // This is non-standard, don't use this an example! We do it this way because
        // we don't actually want to manage the modals through the prop tree, because
        // that would result in circular updates: triggering SHOW_MODAL would result in
        // adding props which would bubble down to the newly shown Modal, which would
        // updated itself because it thinks props have changed. In that design, the update
        // would require triggering another event, thus starting the cycle all over again.
        this.context.dispatcher.register(this, { autoBind: false });
    },

    showModal(e) {
        let state = {};
        state[e.data.modalKey] = e.data;
        this.setState(state);
    },

    hideModal(e) {
        // A modal will always be hidden on "HIDE_MODAL", even if its isOpen prop is not correctly set to false.
        let modalKey = e.data.modalKey;
        let state = omit(this.state, modalKey);
        // No more modals are visible.
        if (!some(state)) {
            bodyScrollLockManager.unlock();
        }
        this.replaceState(state);
    },

    close(modalKey) {
        this.context.dispatcher.emit("HIDE_MODAL", { modalKey });
    },

    render() {
        const modals = this.state || {};
        const modalKeys = keys(modals);
        const lockScrollBar = some(modals, m => !m.allowScrollBar);
        let components = [];
        let hideOnClickKey;
        let handleClick;
        if (modalKeys) {
            hideOnClickKey = findLast(modalKeys, key => modals[key].shouldCloseOnOverlayClick);
            if (hideOnClickKey) {
                handleClick = this.close.bind(this, hideOnClickKey);
            }
            components = map(modalKeys, key => {
                const modal = modals[key];
                return (
                    // eslint-disable-next-line
                    <div
                        key={key}
                        className={classNames("modal-overlay", modal.customOverlayClassName)}
                        onClick={handleClick}
                        role="dialog"
                    >
                        <ModalPortal {...modal} />
                    </div>
                );
            });
        }

        return (
            <TransitionGroup>
                {map(components, (component, i) => {
                    // intentional use of i as key so that re-renders don't re-transition an already visible modal
                    return (
                        <CSSTransition
                            key={i}
                            timeout={500}
                            classNames="modal"
                            onEntered={() => bodyScrollLockManager.lock(lockScrollBar)}
                        >
                            {component}
                        </CSSTransition>
                    );
                })}
            </TransitionGroup>
        );
    }
});

ModalContainer.contextType = ActionRootContext;

export default ModalContainer;
